import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        appblelockarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_APPBLELOCKLIST: (state, obj) => {

            state.total = obj.total
            state.appblelockarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.appblelockarr.splice(index,1)
        },
        CLEAR_APPBLELOCKLIST: (state) => {

            state.total = 0
            state.appblelockarr=[]

        },


    },
    actions: {
        async getBlelocklist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getblelocklist(params)
            if (code == 200) {
                commit('SET_APPBLELOCKLIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}